export const monitorRoutes = [
    {
        path: '/monitor',
        name: 'monitor',
        meta: {
            requiresAuth: true,
            accessId: 'monitor',
        },
        component: () =>
            import ('../views/Monitor.vue')
    },
    // {
    //     path: '/monitor/:subjectId',
    //     name: 'scorecard-details',
    //     component: () =>
    //         import ('../views/Details.vue')
    // },
]